import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MaximumCategory } from 'app/models/maximumcategory';
import { ReportsService } from 'app/services';
import { LimitsConstant } from 'app/limits/limitsconstant';
import { ElementData } from '../../models/elementdata';
import { NumberConstants } from "../../common/numberconstants";
import { Globals } from 'app/common/globals';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentsService } from 'app/services/enviornment.service';
import { Subscription } from 'rxjs';


@Component({
  templateUrl: './categorymodal.component.html',
  styleUrls: ['./categorymodal.component.scss'],
  selector: 'categorymodal'
})
export class CategoryModalComponent {

  @Input()
  btnText = 'OK!';
  @Output() onBtnSelection = new EventEmitter<any>();

  show = false;
  showSuggestions: boolean=false;
  maximum: any;
  category: any;
  prod: string;
  version: string;
  namesArray: any[];
  activeClass: string;
  nameForm: string;
  currentAutoCmpt: string;
  message: string = this.translateService.instant('editNote')
  categorySortType:ElementData;
  subCategorySortype:ElementData=ElementData.getselectSortValue(this.globals.subCatSortOrder, false);
  categorySortaData:ElementData = ElementData.getVersiondata(this.globals.newCategoryLabel); 
  subCategorySortaData:ElementData = ElementData.getVersiondata(this.globals.newSubCategoryLabel);
  allCategoriesdata:any;
  catSotVal:any;
  langSub: Subscription;
  DEFAULTSORTTYPE:number = this.numberconstants.ZERO;

  constructor(private reportservice: ReportsService, private limitsconstant: LimitsConstant,private numberconstants: NumberConstants,private globals: Globals, private translateService: TranslateService, private envService: EnvironmentsService) {
  }
  ngOnInit(){
    this.langSub = this.envService.selectedLanguage$.subscribe((lang)=>{
      this.message = this.translateService.instant('editNote');
    });
  }
  open(maximum: any, prod: string, vername: string) {
    this.show = true;
    this.onChangeSort();
    this.categorySortType = ElementData.getselectSortValue(this.globals.catSortOrder, false);   
    let maximumCategory = new MaximumCategory();
    maximumCategory.description = maximum.comments;
    maximumCategory.id = maximum.categoryId;
    maximumCategory.primaryAuthor = maximum.primaryAuthor;
    maximumCategory.secondaryAuthor = maximum.secondaryAuthor;
    if (maximum.subcategoryId != undefined) {
      let catArr = maximum.name.split(":");
      maximumCategory.category = catArr[this.numberconstants.ZERO].trim();
      maximumCategory.subCategory = catArr[this.numberconstants.ONE].trim();
      maximumCategory.child = true;
    } else {
      maximumCategory.category = maximum.name.trim();
      maximumCategory.child = false;
    }
    this.category = maximumCategory;
    this.maximum = maximum;
    this.prod = prod;
    this.version = vername;
  }

  updateMaximum(): void {
    this.category.secondaryAuthor = this.maximum.primaryAuthor;
    this.category.isSupport = true;
    this.category.accessType = "GLOBAL";
    let catSort :any = this.categorySortType.selectedValue;
    if(this.categorySortType.selectedValue != undefined)
    this.category.catSortType = this.categorySortType.selectedValue['id'];
    if(this.subCategorySortype.selectedValue != undefined)
    this.category.subCatSortType = this.subCategorySortype.selectedValue['id'];
    if(this.categorySortaData.selectedValue != undefined)  
    this.category.catSelectedSortNumber = this.categorySortaData.selectedValue['sortorder'];
    if(this.category.catSortType == this.DEFAULTSORTTYPE)
    this.category.catSortorder = this.maximum.catSortOrder;
    else
    this.category.catSortorder = this.numberconstants.ZERO;
    if(this.subCategorySortaData.selectedValue != undefined)  
      this.category.subCatSelectedSortNumber = this.subCategorySortaData.selectedValue['sortorder'];
    this.show = false;
    this.onBtnSelection.emit(this.category);
  }

  getSuggestData(event: any) {
    this.currentAutoCmpt = event.target.id;
    if (event.target.value == '') {
      this.activeClass = '';
    } else {
      if (event.target.id == 'primaryAuthor') {
        this.activeClass = 'active';
      }
      this.reportservice.getSuggestData(event.target.value)
        .subscribe(suggestData => {
          this.namesArray = suggestData;
        }, //Bind to view
          err => {
            // Log errors if any
            console.log(err);
            this.closeDrpDwn();
          });
    }
  }


  closeDrpDwn() {
    if (this.currentAutoCmpt == 'primaryAuthor') {
      this.activeClass = '';
    }

  }

  setSortOptions(isCat: boolean): any {
    let sortoptions = new Array();
    sortoptions.push({ id: this.numberconstants.ZERO, value: this.translateService.instant('default'), isCat: isCat, sort: this.numberconstants.ZERO });
    sortoptions.push({ id: this.numberconstants.TWO, value: this.translateService.instant('before'), isCat: isCat, sort: this.numberconstants.ZERO });
    sortoptions.push({ id: this.numberconstants.ONE, value: this.translateService.instant('after'), isCat: isCat, sort: this.numberconstants.ZERO });
    return sortoptions;
  }

  onChangeSort() {
    this.reportservice.getMaximumCategoriesByProductIdAndVersionId(this.reportservice.selectedprodID, this.reportservice.selectedversionID)
      .subscribe(vmwareproductsMaximums => {
        if(vmwareproductsMaximums!= undefined && vmwareproductsMaximums.length >0) {
        let arr: any = new Array();
        let subcatarr: any = new Array();
        var selectedId = vmwareproductsMaximums[this.numberconstants.SELECTEDOBJECT].id;
        this.allCategoriesdata = vmwareproductsMaximums;
        let selectedCategory: any;
        vmwareproductsMaximums.forEach(element => {
          if (element.id == this.maximum.categoryId)
            selectedCategory = element;
            else
            arr.push({ id: element.id, value: element.category, cat: this.numberconstants.ZERO, sortorder: element.catSortorder, checked: false, isCat: true });
        });
        this.categorySortaData.options = arr;
        this.categorySortaData.selectedValue = arr[this.numberconstants.ZERO];
        this.onChangeCategory(selectedCategory);
        this.categorySortType.options = this.setSortOptions(true);
        this.categorySortType.selectedValue = this.categorySortType.options[this.numberconstants.ZERO];
        this.subCategorySortype.options = this.setSortOptions(false);
        this.subCategorySortype.selectedValue = this.subCategorySortype.options[this.numberconstants.ZERO];
        this.categorySortaData.hidden = true;
        this.subCategorySortaData.hidden = true;
        }
      },
      err => {
        // Log errors if any
        console.log(err)
      });
  }
  onChangeSetSort(element: any): void {
    if (element.isCat) {
      if (element.value === this.translateService.instant('default'))
        this.categorySortaData.hidden = true;
      else
        this.categorySortaData.hidden = false;
    }
    else {
      if (element.value === this.translateService.instant('default'))
        this.subCategorySortaData.hidden = true;
      else
        this.subCategorySortaData.hidden = false;

    }
  }

  onChangeCategory(selectedElement): void {
    let subcatarr: any = new Array();
    if (this.allCategoriesdata != undefined) {
      this.allCategoriesdata.forEach(element => {
        if (element.subcategories != undefined && element.subcategories.length >= this.numberconstants.ZERO && selectedElement.id == element.id) {
          element.subcategories.forEach(subelement => {
            subcatarr.push({ id: subelement.id, value: subelement.subCategory, sortorder: subelement.sortOrder, catId: element.id, isCat: false });
          });
        }
      });
      this.subCategorySortaData.options = subcatarr;
      this.subCategorySortaData.selectedValue = subcatarr[this.numberconstants.ZERO];
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/limits/categorymodal/categorymodal.component.ts